import { tsValidateMustExist } from '@nu-art/ts-common';
// const Validator_ModifiableProps: DBProto_DeletedDoc['modifiablePropsValidator'] = {
// 	__docId: tsValidateUniqueId,
// 	__collectionName: tsValidateString(),
// };
const Validator_GeneratedProps = {};
export const DBDef_DeletedDoc = {
    modifiablePropsValidator: tsValidateMustExist,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.0'],
    dbKey: '__deleted__docs',
    entityName: 'DeletedDoc',
    frontend: {
        group: 'ts-default',
        name: 'deleted-doc'
    },
    backend: {
        name: '__deleted__docs'
    }
};
//# sourceMappingURL=db-def.js.map